module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "4rem"
    }
  }, [_c('div', {
    staticClass: "swiper-container",
    style: (_vm.hight),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(banner) {
    return (!banner.imgUrlProduct && banner.param) ? _c('img', {
      staticClass: "swiper-slide",
      attrs: {
        "src": banner.imgUrl
      },
      on: {
        "click": function($event) {
          _vm.goToRecommend(banner)
        }
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf81839a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/Banner.vue
// module id = 215
// module chunks = 2